import { render, staticRenderFns } from "./AsamAssessmentChartReview.vue?vue&type=template&id=cf5b7a62&"
import script from "./AsamAssessmentChartReview.vue?vue&type=script&lang=js&"
export * from "./AsamAssessmentChartReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports